import axios from "axios";
import SHA256 from "crypto-js/sha256";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;
const JSON_HEADERS = { "Content-Type": "application/json" };

// Keep only a digest and key in memory; never persist signup credentials.
// A failed/ambiguous response must retain the key for an unchanged retry.
let pendingSignup = null;
const signupRequestKey = () => {
  const cryptoApi = globalThis.crypto;
  if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
  const bytes = new Uint8Array(16);
  if (cryptoApi?.getRandomValues) cryptoApi.getRandomValues(bytes);
  else bytes.forEach((_, index) => { bytes[index] = Math.floor(Math.random() * 256); });
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

const create = (values) => {
  const action = "beforelogin/salons/store";
  const payload = { ...values, business_email: values && values.email };
  const fingerprint = SHA256(JSON.stringify(payload, (_, value) => (
    value && typeof value === "object" && !Array.isArray(value)
      ? Object.fromEntries(Object.keys(value).sort().map((key) => [key, value[key]]))
      : value
  ))).toString();
  if (!pendingSignup || pendingSignup.fingerprint !== fingerprint) {
    pendingSignup = { fingerprint, key: signupRequestKey() };
  }
  const attempt = pendingSignup;
  return axios.post(
    API_URL + action,
    payload,
    { headers: { ...JSON_HEADERS, "Idempotency-Key": attempt.key } },
  ).then((response) => {
    if (pendingSignup === attempt) pendingSignup = null;
    return response;
  });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["working_hours"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, JSON.stringify(values[value]));
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/categories/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  formData.append("role_id", 6);
  formData.append("salon_id", auth.user.salon_id);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const checkexist = (values) => {
  const action = "beforelogin/salons/checkexist";
  return axios.post(
    API_URL + action,
    { ...values, business_email: values && values.email },
    { headers: JSON_HEADERS },
  );
};

const isexist = (values) => {
  const action = "beforelogin/salons/isexist";
  return axios.post(API_URL + action, values, { headers: JSON_HEADERS });
};

const requestVerification = ({ channel, destination, country_code }) => axios.post(
  API_URL + "beforelogin/signup/verification/request",
  { channel, destination, ...(country_code ? { country_code } : {}) },
  { headers: JSON_HEADERS },
);

const verifyVerification = ({ challenge_id, otp }) => axios.post(
  API_URL + "beforelogin/signup/verification/verify",
  { challenge_id, otp },
  { headers: JSON_HEADERS },
);

const signupApiController = {
  create,
  update,
  checkexist,
  isexist,
  requestVerification,
  verifyVerification,
};
export default signupApiController;
